module.exports = __webpack_public_path__ + "static/media/24UHCHR17.4217b01f.jpg";